const ONE = '1';
const MAX_GUESTS = 20;
const getOptions = (oneGuest, getNumberGuests, shopSmallMaxGuest) => {
  const initMaxGuests = shopSmallMaxGuest || MAX_GUESTS;
  const options = [{ value: ONE, key: ONE, label: oneGuest }];

  for (let n = 2; n <= initMaxGuests; n += 1) {
    const NUMBER = `${n}`;
    const label = getNumberGuests(n);
    options.push({ value: NUMBER, key: NUMBER, label });
  }

  return options;
};

export default getOptions;
